export default __webpack_public_path__ + "static/media/icons-to-remember.00068d14.png";